<template>
  <!-- Modal -->
  <div
    class="modal fade"
    :id="modalId"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
          <div class="row g-3">
            <div class="col-12">
              <label for="form_order_status" class="form-label"
                >受注状態<span class="badge text-bg-danger ms-2 px-1"
                  >必須</span
                ></label
              >
              <select
                v-model="formData.status"
                class="form-select"
                :class="{ 'is-invalid': formErrors?.status }"
                id="form_order_status"
              >
                <option :value="undefined">---</option>
                <option
                  v-for="(status, index) in statusList"
                  :key="index"
                  :value="status.value"
                >
                  {{ status.name }}
                </option>
              </select>
              <div v-if="formErrors?.status" class="invalid-feedback">
                {{ formErrors.status }}
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            閉じる
          </button>
          <button
            type="button"
            class="btn btn-dark"
            v-on:click.prevent="formSubmit()"
          >
            <slot name="submitButton">保存</slot>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../store'
import { Modal } from 'bootstrap/dist/js/bootstrap.esm.min.js'
import { randomString } from '@/utils/stringUtils.js'

export default {
  name: 'OrderStatusUpdateForm',
  components: {},

  emits: ['hiddenModal', 'afterSubmit'],

  data() {
    return {
      modal: null,
      formData: {},
      formErrors: {},
    }
  },
  computed: {
    statusList() {
      return store.getters['manage_order/statusList']
    },
    modalId: function () {
      return 'form-modal-' + this.randomString()
    },
  },

  async created() {
    await this.getStatusList()
  },

  mounted() {
    this.modal = new Modal(document.getElementById(this.modalId))
    document
      .getElementById(this.modalId)
      .addEventListener('hidden.bs.modal', () => {
        this.formErrors = {}
        this.$emit('hiddenModal')
      })
  },
  beforeUnmount() {
    this.modal.hide()
  },

  methods: {
    randomString,
    getStatusList() {
      return store.dispatch('manage_order/fetchStatusList')
    },
    statusUpdate(formData) {
      return store.dispatch('manage_order/statusUpdate', formData)
    },
    show(formData = {}) {
      this.formData = Object.assign({}, formData)
      this.modal.show()
    },
    async formSubmit() {
      this.formErrors = {}
      if (!this.formData.status) {
        this.formErrors.status = '受注状態を選択してください。'
      }
      if (Object.keys(this.formErrors).length > 0) {
        return
      }
      try {
        this.formErrors = {}
        await this.statusUpdate(this.formData)
        this.$store.dispatch('alert/setSuccessMessage', {
          message: '更新しました。',
        })
        await this.$emit('afterSubmit', this.formData)
        await this.modal.hide()
      } catch (e) {
        if (e.response.status == 400) {
          Object.keys(e.response.data).forEach((key) => {
            this.setErrorMessage(key, e.response.data[key])
          })
        }
      }
    },
    setErrorMessage(key, errorData) {
      if (Array.isArray(errorData)) {
        this.formErrors[key] = errorData.join('\n')
      } else {
        this.formErrors[key] = errorData
      }
    },
  },
}
</script>
